<div class="user-dropdown">
  <div class="form-group" *ngIf="label">
    <label class="form-label" [for]="identifier">{{ label }}</label>
  </div>
  
  <sparkplus-dropdown
    [items]="userDropdownItems"
    [selectedItem]="selectedUserId"
    [isOpen]="isDropdownOpen"
    [id]="identifier"
    (onSelection)="onUserSelectedInternal($event)"
    (onClose)="closeDropdown()">
    <dropdown-toggle>
      <div class="dropdown-toggle-custom" 
           [class.disabled]="disabled"
           [class.dropdown-open]="isDropdownOpen"
           (click)="toggleDropdown($event)"
           [tabindex]="disabled ? -1 : 0"
           role="button"
           [attr.aria-expanded]="isDropdownOpen"
           [attr.aria-haspopup]="true"
           [attr.aria-label]="'Select user dropdown'"
           (keydown.enter)="toggleDropdown($event)"
           (keydown.space)="toggleDropdown($event)">
        <span class="toggle-text">{{ getSelectedUserDisplay() }}</span>
        <i class="fa fa-chevron-down toggle-icon" 
           [class.rotated]="isDropdownOpen"
           [class.disabled]="disabled"></i>
      </div>
    </dropdown-toggle>
  </sparkplus-dropdown>
</div>
